import { render } from "./Register.vue?vue&type=template&id=089290d6&scoped=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=089290d6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-089290d6"

export default script